import { Injectable } from "@angular/core";
import { ApiService } from "@drl/core/api/api.service";
import { CreateAppointment } from "./shared/commands/add-appointment.command";
import { HttpHeaders } from "@angular/common/http";
import { AppointmentAdapter } from "./shared/adapters/appointment-adapters.service";
import { AppointmentBulk } from "./appointment-bulk.model";

@Injectable()
export class PatientDataFacadeService {
  constructor(
    private readonly apiService: ApiService,
    private readonly apptAdapter: AppointmentAdapter
  ) {}

  createBulkAppointment(appts:AppointmentBulk){
    const command: CreateAppointment<AppointmentBulk> = new CreateAppointment(
      this.apiService,
      this.apptAdapter
    );
    command.parameters = {
        data: appts,
        headers: new HttpHeaders().set('X-Skip-Error-Toast', 'true'),
    };
    return command.execute();
  }
}